import { heroHighlights } from "@/content/coletor-publico-landing";

const BANNER_URL =
  "https://static.readdy.ai/image/f0e3ea51be3a6053767e026ea9261140/485070128fc0239e6e91bd6f057c30c4.png";

const badgesRow1 = ["CTA Arbóreo", "GIS Ambiental"];
const badgesRow2 = ["Carbono Urbano", "Cidades Inteligentes"];

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex flex-col">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${BANNER_URL})` }}
      />

      {/* Very subtle overlay — just enough depth without killing the image */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center max-w-7xl mx-auto px-4 md:px-6 lg:px-8 xl:px-12 w-full pt-20 md:pt-28 pb-16 md:pb-20">
        {/* Main content wrapper — anchored hard to the right, FloraIQ branding fully visible */}
        <div className="w-full flex justify-start md:justify-end">
          {/* Translucent panel — balanced width, anchored right */}
          <div
            className="w-full md:w-auto md:max-w-[340px] rounded-none md:rounded-[22px] p-6 md:p-8 lg:p-10"
            style={{
              background: "rgba(0, 30, 40, 0.42)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
              border: "1px solid rgba(255,255,255,0.12)",
            }}
          >
            {/* Badges — two rows, right aligned */}
            <div className="flex flex-col items-start md:items-end gap-2 mb-4 md:mb-5">
              <div className="flex flex-wrap gap-2 justify-start md:justify-end">
                {badgesRow1.map((badge) => (
                  <span
                    key={badge}
                    className="px-3 py-1.5 text-xs font-semibold bg-white/[0.07] text-white/90 border border-white/15 rounded-full whitespace-nowrap"
                  >
                    {badge}
                  </span>
                ))}
              </div>
              <div className="flex flex-wrap gap-2 justify-start md:justify-end">
                {badgesRow2.map((badge) => (
                  <span
                    key={badge}
                    className="px-3 py-1.5 text-xs font-semibold bg-white/[0.07] text-white/90 border border-white/15 rounded-full whitespace-nowrap"
                  >
                    {badge}
                  </span>
                ))}
              </div>
            </div>

            {/* Title — right-aligned, refined line breaks */}
            <h1
              className="font-bold text-white leading-[1.05] text-left md:text-right mb-3 md:mb-4 max-w-[340px]"
              style={{
                fontSize: "clamp(1.4rem, 2.8vw, 2.1rem)",
                textShadow: "0 2px 10px rgba(0,0,0,0.30)",
              }}
            >
              Inteligência ambiental para cidades mais verdes e inteligentes
            </h1>

            {/* Subtitle — right-aligned, balanced */}
            <p
              className="text-sm md:text-[15px] text-white/90 max-w-[320px] mb-0 leading-relaxed text-left md:text-right md:ml-auto"
              style={{ textShadow: "0 1px 6px rgba(0,0,0,0.25)" }}
            >
              O FloraIQ transforma inventários arbóreos, áreas verdes, vistorias, riscos e carbono urbano em dados georreferenciados para apoiar decisões públicas e privadas.
            </p>
          </div>
        </div>
      </div>

      {/* Destaques da plataforma (sem numeros: a landing nao exibe metricas inventadas) */}
      <div className="relative z-10 w-full pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {heroHighlights.map((stat) => (
              <div
                key={stat.label}
                className="rounded-xl p-3 md:p-4"
                style={{
                  background: "rgba(0, 30, 25, 0.42)",
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                  border: "1px solid rgba(255,255,255,0.12)",
                }}
              >
                <div className="flex items-center gap-2.5 mb-1">
                  <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-white/10">
                    <i
                      className={`${stat.icon} text-white text-sm md:text-base w-full h-full flex items-center justify-center`}
                    />
                  </div>
                  <span className="text-sm md:text-base font-bold text-white leading-tight">
                    {stat.label}
                  </span>
                </div>
                <p className="text-xs text-white/55 pl-[2.75rem] md:pl-[3rem]">
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}